import React, { SelectHTMLAttributes } from "react";
import { useState } from "react";

const Select = ({
  label,
  disabled = false,
  selectedValue,
  onSelect,
  options = [],
  error,
  valueRendered,
  optionsRenderer,
  placeholder,
  ...rest
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="w-full flex flex-col relative mb-2 mt-2">
        {/* <label onClick={() => setOpen(false)} id="listbox-label" className="block text-sm font-medium text-gray-700">
            Assigned to
        </label> */}
        {label && (
          <div className="bg-white ">
            <span className="relative text-xs text-gray-500 uppercase tracking-wide">
              {label}
            </span>
          </div>
        )}
        <div className={`mt-1 relative ${disabled ? "bg-gray-200" : ""}`}>
          <div
            onClick={() => (disabled ? null : setOpen(!open))}
            className="relative py-2 px-2 text-sm  w-full flex flex-row justify-center items-center border border-solid border-gray-300 rounded focus:outline-none focus:border-gray-600  focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          >
            <span className="flex flex-1 items-center">
              {!(selectedValue && selectedValue.value) ? (
                <span className="text-gray-400">{placeholder || "Select"}</span>
              ) : (
                <span className="text-black">
                  {valueRendered
                    ? valueRendered(selectedValue)
                    : selectedValue.label}
                </span>
              )}
            </span>
            <span className="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
              <svg
                className="h-5 w-5 text-gray-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </span>
          </div>

          {open && (
            <ul
              className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
              // tabindex="-1"
            >
              {options.map((data, ind) => {
                return (
                  <li
                    key={ind}
                    onClick={() => {
                      onSelect(data);
                      setOpen(false);
                    }}
                    className="text-gray-900 cursor-default select-none relative py-2 pl-3 pr-9 hover:bg-slate-200"
                  >
                    <div className="flex items-center">
                      {optionsRenderer ? (
                        optionsRenderer(data, {
                          isSelected: data.value === selectedValue?.value,
                        })
                      ) : (
                        <>
                          <span className="font-normal ml-3 block truncate">
                            {data.label}
                          </span>
                          {data.value === selectedValue?.value && (
                            <span className="ml-3 text-sm text-gray-600">
                              {/* check svg icon */}
                              ✔️
                            </span>
                          )}
                        </>
                      )}
                    </div>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
        {error?.message && (
          <div className="text-xs text-pink-800">{error?.message}</div>
        )}
      </div>
    </>
  );
};
export default Select;
